import type { AxiosInstance } from 'axios';
import type { ApiEmptyResponse, ApiResponseType, Target, WatchListGetQueryParams } from '~/service/api/types';

export default (axiosInstance: AxiosInstance) => ({

    /**
     * @description get watch list
     *
     * @tags watch_list
     * @name GetWatchList
     * @request GET:/watch-list/
     * @secure
     * @response `200` `GetWatchListData` success updating target in watch list
     * @response `default` `EmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any data answers
     */
    async watchListsGet(params: WatchListGetQueryParams = {}) {
        const res = await axiosInstance.get<ApiResponseType<Target[]>>(
            `/v1/watch-list`,
            { withCredentials: true, params }
        );
        return res.data;
    },

    /**
     * @description remove target from watch list
     *
     * @tags watch_list
     * @name RemoveTargetFromWatchList
     * @request DELETE:/watch-list/
     * @secure
     * @response `200` `RemoveTargetFromWatchListData`
     * @response `default` `EmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any data answers
     */
    async removeFromWatchList(uuid: string) {
        const res = await axiosInstance.delete<ApiEmptyResponse>(`/v1/watch-list`, {
            withCredentials: true,
            params: {
                uuid
            }
        });
        return res.data;
    },

    /**
     * @description add target to watch list
     *
     * @tags watch_list
     * @name AddToWatchList
     * @request PUT:/watch-list/
     * @secure
     * @response `200` `AddToWatchListData` success adding target to watch list
     * @response `default` `EmptyResponse` universal response is used for NoContent and AnyError answers, contains field Status as any data answers
     */
    async addToWatchList(target: Target) {
        const res = await axiosInstance.put<ApiEmptyResponse>(`/v1/watch-list`, target, {
            withCredentials: true
        });
        return res.data;
    }

} as const);
